import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { getAddressComponentByType, useGoogleAPI } from "@jti/fe-clients";
import { DEPRECATED_TextInput } from "../../../../components/DEPRECATED_TextInput";
import { useConfig } from "../../../../providers/useConfig";
import { useTranslations } from "../../../../providers/useTranslations";
import { initAutocomplete } from "../../initAutocomplete";
const prepareGoogleAutocompleteResults = (place, addressComponentTypes = {}) => {
    const cityComponentTypes = addressComponentTypes.city ?? ["locality", "postal_town", "sublocality_level_1"];
    return {
        city: getAddressComponentByType(place, cityComponentTypes)?.long_name ?? "",
        /*
        Barangay is the smallest administrative division in the Philippines and is equivalent to a district in other countries
        We use the variable named *districtName* to store this value
        */
        districtName: getAddressComponentByType(place, ["sublocality", "sublocality_level_1", "sublocality_level_1"])?.long_name ?? "",
        postcode: getAddressComponentByType(place, ["postal_code"])?.long_name ?? "",
        provinceName: getAddressComponentByType(place, ["administrative_area_level_1"])?.long_name ?? "",
        streetName: getAddressComponentByType(place, ["route"])?.long_name ?? "",
        streetNumber: getAddressComponentByType(place, ["street_number"])?.long_name ?? "",
    };
};
export const GooglePlaceInput = ({ onPlace, ...props }) => {
    const { __ } = useTranslations();
    const _google = useGoogleAPI();
    const config = useConfig();
    const ref = useRef(null);
    const onResults = useCallback((place) => {
        const addressComponentTypes = {
            city: config.googleMapsCityComponentType ? config.googleMapsCityComponentType.split(",") : undefined,
        };
        onPlace(prepareGoogleAutocompleteResults(place, addressComponentTypes));
    }, [onPlace]);
    useEffect(() => {
        if (typeof ref !== "function" && ref?.current && _google) {
            initAutocomplete(_google, ref.current, config.ISO_COUNTRY_CODE, onResults);
        }
        // adding onPlace to useEffect dependencies will end with multiple unwanted initializations
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_google, ref]);
    return (_jsx(DEPRECATED_TextInput, { "aria-label": __("address_fields.street_name"), dataTestId: "placeAutocompleteInput", autoComplete: "street-name", ...props, ref: ref }));
};
//# sourceMappingURL=GooglePlaceInput.js.map